import styled from "styled-components";

export const HeaderRow = styled.tr`
  height: 56px;
`;

export const HeaderCell = styled.th`
  box-sizing: border-box;
  background-color: #d9d9d9;
  white-space: nowrap;
  overflow: hidden;
  border-right: 1px solid #666666;
  height: 56px;
  vertical-align: middle;

  &:first-child {
    border-right: none;
  }
`;

export const HeaderCellContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  min-width: 0;
  height: 100%;
  color: #0e0e0e;
  padding: 0 16px;
  gap: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HideColumnButton = styled.button`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
`;
